<template>
  <div class="loader-container"><div class="loader" /></div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.loader-container {
  position: absolute;
  left: 47%;
  top: 47%;
  transform: translate(-47%, -47%);
}

.loader {
  user-select: none;
  transition: all 0.5s ease-in;
}
</style>
